module.exports = __webpack_public_path__ + "static/media/PDF_116.21655be5.pdf";